import { render } from "./tender_description.vue?vue&type=template&id=00d12168"
import script from "./tender_description.vue?vue&type=script&lang=js"
export * from "./tender_description.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/inside/tabs/tender_description.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00d12168"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00d12168', __exports__)) {
    console.log('reload')
    api.reload('00d12168', __exports__)
  }
  
  module.hot.accept("./tender_description.vue?vue&type=template&id=00d12168", () => {
    console.log('re-render')
    api.rerender('00d12168', render)
  })

}


export default __exports__